app.controller('BrowseNavigationContextController', ['$rootScope', '$scope', function ($rootScope, $scope) {


    let nextParent = $scope.$parent;
    let stateIndex = 0;

    while (nextParent) {
        nextParent = nextParent.$parent;
        if (!nextParent) {
            break;
        }
        if (nextParent.hasOwnProperty('context_state_index')) {
            stateIndex = nextParent.context_state_index + 1;
            break;
        }
    }


    $scope.context_state_index = stateIndex;
    const parentStateIndex = stateIndex - 1;

    $scope.context_include = null;

    let contextChoice = null;
    let contextModel = null;
    let haveContext = false;

    $scope.checkContext = function () {
        if (parentStateIndex > $rootScope.navigation_model.choice_count - 1) {
            haveContext = false;
            contextChoice = null;
            contextModel = null;
            $scope.context_include = null;
            return false;
        }
        const stateList = $rootScope.navigation_model.state_list;
        const choice = stateIndex > 0 && stateList[stateIndex - 1] ? stateList[stateIndex - 1].choice : null;
        const model = stateList[stateIndex] ? stateList[stateIndex].model : null;
        if (haveContext) {
            if (choice === contextChoice && model === contextModel) {
                return true;
            }
            haveContext = false;
            contextChoice = null;
            contextModel = null;
            $scope.context_include = null;
            return false;
        }

        haveContext = true;
        contextChoice = choice;
        contextModel = model;

        $scope.navigation_ids = $rootScope.navigation_manager.getStateIDs(stateIndex);
        $scope.navigation_values = $rootScope.navigation_manager.getStateValues(stateIndex);
        $scope.context_include = $rootScope.template_config.getTemplate($rootScope.navigation_model, stateIndex);

        return true;
    }


    $scope.getContextModel = function () {
        return contextModel;
    }

    $scope.doShowTemplate = function () {
        if (!haveContext) {
            return false;
        }

        if (!contextModel) {
            return true;
        }
        return $scope.isModelVisible(contextModel);

    }

    $scope.isChoiceSelected = function (choiceID) {
        const navigationPointer = contextModel ? contextModel.navigation_pointer : null;
        return navigationPointer && ($rootScope.navigation_model.state_ids[navigationPointer] === choiceID);
    }

    $scope.onChoiceSelected = function (event, choiceID) {
        return true;
    }

}])